import { render, staticRenderFns } from "./px-button.vue?vue&type=template&id=bad60872&scoped=true&"
import script from "./px-button.vue?vue&type=script&lang=ts&"
export * from "./px-button.vue?vue&type=script&lang=ts&"
import style0 from "./px-button.vue?vue&type=style&index=0&id=bad60872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad60872",
  null
  
)

export default component.exports